<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៤.ក.ខ.គ.ឃ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៤.ង.ច
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <staffsal :data="sta_sal" :title="title[1]" />
            <staffteach :data="sta_tea" title="" />
          </div>
          <div>
            <stafftente :data="sta_fun" :cur_cod="cur_cod" :title="title[2]" />
          </div>
          <div>
            <secempcontract :data="sta_eect" :title="title[3]" />
          </div>
          <div>
            <extrahour :data="sta_ets" :title="title[4]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <staffedu :data="sta_tra" :title="title[5]" />
          </div>
          <div>
            <extrasubject :data="sta_ess" :title="title[6]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import staffSalary from "@/components/ascf/sharedCom/staffSalary.vue";
import staffTenTe from "@/components/ascf/sec/staffTenTe.vue";
import staffEducation from "@/components/ascf/sharedCom/staffEducation.vue";
import staffTeach from "@/components/ascf/sec/staffTeachSec.vue";
import extraHour from "@/components/ascf/sec/extraHourSec.vue";
import extraSubject from "@/components/ascf/sec/extraSubjectSec.vue";
import secEmpContract from "@/components/ascf/sec/secEmpContract.vue";

export default {
  props: [
    "title",
    "sta_sal",
    "sta_tea",
    "sta_fun",
    "sta_ets",
    "sta_tra",
    "sta_ess",
    "sta_eect",
    "cur_cod",
  ],
  components: {
    staffsal: staffSalary,
    stafftente: staffTenTe,
    staffedu: staffEducation,
    staffteach: staffTeach,
    extrahour: extraHour,
    extrasubject: extraSubject,
    secempcontract: secEmpContract
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.col {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>